import { tabs } from '../../../../../../views/dashboard/service-provider';

export default {
  tabs: {
    [tabs.general]: 'General',
    [tabs.restaurant_details]: 'Detalles del restaurante',
    [tabs.order_conversion]: 'Conversión de pedidos',
    [tabs.external_delivery]: 'Entrega externa',
    [tabs.mobile_app]: 'App móvil',
    [tabs.customer_success_team]: 'Equipo de éxito del cliente',
    [tabs.onboarding_team]: 'Equipo de incorporación',
  },
  date_range: {
    this_month: 'Este mes',
    last_month: 'Mes pasado',
    last_week: 'Semana pasada',
    last_year: 'Año pasado',
    this_week: 'Esta semana',
    this_year: 'Este año',
    today: 'Hoy',
    yesterday: 'Ayer',
    all: 'Todo',
  },
};
